import { useNavigate } from "react-router-dom";

const Nyaynet404 = () => {
  const navigate = useNavigate();
  // SVG Icons
  const ScaleIcon = ({ size = 24, className = "" }) => (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      className={className}
    >
      <path d="M16 11V7a4 4 0 0 0-8 0v4" />
      <path d="M5 11h14" />
      <path d="M5 11l2 8h10l2-8" />
    </svg>
  );

  const HomeIcon = ({ size = 20, className = "" }) => (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      className={className}
    >
      <path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z" />
      <polyline points="9,22 9,12 15,12 15,22" />
    </svg>
  );

  const BookIcon = ({ size = 20, className = "" }) => (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      className={className}
    >
      <path d="M4 19.5A2.5 2.5 0 0 1 6.5 17H20" />
      <path d="M6.5 2H20v20H6.5A2.5 2.5 0 0 1 4 19.5v-15A2.5 2.5 0 0 1 6.5 2z" />
    </svg>
  );

  const ArrowLeftIcon = ({ size = 20, className = "" }) => (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      className={className}
    >
      <path d="m12 19-7-7 7-7" />
      <path d="M19 12H5" />
    </svg>
  );

  return (
    <div className="min-h-screen bg-gradient-to-br from-blue-50 via-white to-indigo-50 flex items-center justify-center p-4">
      <div className="max-w-4xl mx-auto text-center">
        {/* Main 404 Content */}
        <div className="relative">
          {/* Background decoration */}
          <div className="absolute inset-0 flex items-center justify-center opacity-5">
            <ScaleIcon size={400} className="text-blue-600" />
          </div>

          {/* Content */}
          <div className="relative z-10">
            {/* Logo/Brand */}
            <div className="flex items-center justify-center mb-8">
              <div className="flex items-center gap-3">
                <div className="w-12 h-12 bg-gradient-to-r from-blue-600 to-indigo-600 rounded-lg flex items-center justify-center shadow-lg">
                  <ScaleIcon size={24} className="text-white" />
                </div>
                <div className="text-left">
                  <h1 className="text-2xl font-bold text-gray-900">NyayNet</h1>
                  <p className="text-sm text-gray-600">
                    Legal Technology Platform
                  </p>
                </div>
              </div>
            </div>

            {/* 404 Number */}
            <div className="mb-8">
              <h2 className="text-8xl md:text-9xl font-extrabold text-transparent bg-gradient-to-r from-blue-600 via-purple-600 to-indigo-600 bg-clip-text mb-4">
                404
              </h2>
              <div className="w-24 h-1 bg-gradient-to-r from-blue-600 to-indigo-600 mx-auto rounded-full"></div>
            </div>

            {/* Error Message */}
            <div className="mb-12">
              <h3 className="text-2xl md:text-3xl font-bold text-gray-900 mb-4">
                Case Not Found in Court Records
              </h3>
              <p className="text-lg text-gray-600 mb-2">
                The page you're looking for seems to have been dismissed from
                the docket.
              </p>
              <p className="text-gray-500">
                Don't worry, justice will be served! Let's help you find what
                you need.
              </p>
            </div>

            {/* Quick Actions */}
            {/* <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4 mb-12 max-w-4xl mx-auto">
              <div className="bg-white rounded-xl shadow-sm border border-gray-200 p-6 hover:shadow-lg transition-all duration-300 hover:scale-105 group cursor-pointer">
                <div className="w-12 h-12 bg-blue-100 rounded-lg flex items-center justify-center mb-4 group-hover:bg-blue-600 transition-colors">
                  <HomeIcon className="text-blue-600 group-hover:text-white transition-colors" />
                </div>
                <h4 className="font-semibold text-gray-900 mb-2">Dashboard</h4>
                <p className="text-sm text-gray-600">
                  Return to your legal dashboard
                </p>
              </div>

              <div className="bg-white rounded-xl shadow-sm border border-gray-200 p-6 hover:shadow-lg transition-all duration-300 hover:scale-105 group cursor-pointer">
                <div className="w-12 h-12 bg-green-100 rounded-lg flex items-center justify-center mb-4 group-hover:bg-green-600 transition-colors">
                  <SearchIcon className="text-green-600 group-hover:text-white transition-colors" />
                </div>
                <h4 className="font-semibold text-gray-900 mb-2">
                  Case Search
                </h4>
                <p className="text-sm text-gray-600">
                  Search for cases and documents
                </p>
              </div>

              <div className="bg-white rounded-xl shadow-sm border border-gray-200 p-6 hover:shadow-lg transition-all duration-300 hover:scale-105 group cursor-pointer">
                <div className="w-12 h-12 bg-purple-100 rounded-lg flex items-center justify-center mb-4 group-hover:bg-purple-600 transition-colors">
                  <BookIcon className="text-purple-600 group-hover:text-white transition-colors" />
                </div>
                <h4 className="font-semibold text-gray-900 mb-2">
                  Legal Library
                </h4>
                <p className="text-sm text-gray-600">
                  Browse laws and regulations
                </p>
              </div>

              <div className="bg-white rounded-xl shadow-sm border border-gray-200 p-6 hover:shadow-lg transition-all duration-300 hover:scale-105 group cursor-pointer">
                <div className="w-12 h-12 bg-orange-100 rounded-lg flex items-center justify-center mb-4 group-hover:bg-orange-600 transition-colors">
                  <PhoneIcon className="text-orange-600 group-hover:text-white transition-colors" />
                </div>
                <h4 className="font-semibold text-gray-900 mb-2">Support</h4>
                <p className="text-sm text-gray-600">Get help from our team</p>
              </div>
            </div> */}

            {/* Primary Actions */}
            <div className="flex flex-col sm:flex-row gap-4 justify-center items-center mb-12">
              <button
                onClick={() => navigate("/dashboard")}
                className="bg-gradient-to-r from-blue-600 to-indigo-600 text-white px-8 py-4 rounded-xl font-semibold hover:from-blue-700 hover:to-indigo-700 transition-all duration-300 shadow-lg hover:shadow-xl transform hover:scale-105 flex items-center gap-2"
              >
                <HomeIcon size={20} />
                Go to Dashboard
              </button>

              <button
                onClick={() => navigate(-1)}
                className="border-2 border-gray-300 text-gray-700 px-8 py-4 rounded-xl font-semibold hover:border-gray-400 hover:bg-gray-50 transition-all duration-300 flex items-center gap-2"
              >
                <ArrowLeftIcon size={20} />
                Go Back
              </button>
            </div>

            {/* Legal Quote */}
            <div className="mt-16 p-8 bg-gradient-to-r from-blue-50 to-indigo-50 rounded-2xl border border-blue-100 max-w-2xl mx-auto">
              <blockquote className="text-lg italic text-gray-700 mb-4">
                "Justice delayed is justice denied, but a well-designed legal
                system ensures justice is always within reach."
              </blockquote>
              <cite className="text-sm text-gray-500 font-medium">
                — NyayNet Legal Platform
              </cite>
            </div>

            {/* Footer */}
            <div className="mt-16 pt-8 border-t border-gray-200">
              <p className="text-gray-500 text-sm">
                Need immediate assistance? Contact our support team at{" "}
                <a
                  href="mailto:support@nyaynet.com"
                  className="text-blue-600 hover:text-blue-700 font-medium"
                >
                  support@nyaynet.com
                </a>{" "}
                or call{" "}
                <a
                  href="tel:+911800123456"
                  className="text-blue-600 hover:text-blue-700 font-medium"
                >
                  1800-123-456
                </a>
              </p>
            </div>
          </div>
        </div>
      </div>

      {/* Floating Elements */}
      <div className="fixed top-10 left-10 opacity-10 animate-pulse hidden lg:block">
        <ScaleIcon size={64} className="text-blue-600" />
      </div>
      <div className="fixed bottom-10 right-10 opacity-10 animate-pulse hidden lg:block">
        <BookIcon size={64} className="text-indigo-600" />
      </div>
      <div className="fixed top-1/3 right-20 opacity-5 animate-pulse hidden xl:block">
        <ScaleIcon size={96} className="text-purple-600" />
      </div>
    </div>
  );
};

export default Nyaynet404;
